import { Parser } from 'expr-eval';

const parser = new Parser();

export default parser;
